import React from 'react';
import Peca from './Peca';

// tela Atendimento do chat (rota /painel/atendimento): a mesma da Central, vinda do pacote (ver pacote.js)
export default function Atendimento(){
    return <Peca peca="atendimento" />;
}
